import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PaymentFailure: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Redirecionar para premium após alguns segundos
    const timer = setTimeout(() => {
      navigate('/premium');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  if (!user) {
    return <div>Carregando...</div>;
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '20px',
      textAlign: 'center'
    }}>
      <div style={{
        backgroundColor: '#ef4444',
        color: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        maxWidth: '500px',
        width: '100%'
      }}>
        <h1 style={{ margin: '0 0 20px 0', fontSize: '2rem' }}>❌ Pagamento Não Aprovado</h1>
        <p style={{ margin: '0 0 20px 0', fontSize: '1.1rem' }}>
          Houve um problema com seu pagamento. Tente novamente.
        </p>
        <p style={{ margin: '0', fontSize: '0.9rem', opacity: 0.9 }}>
          Você será redirecionado automaticamente em alguns segundos...
        </p>
        <button
          onClick={() => navigate('/premium')}
          style={{
            marginTop: '20px',
            padding: '12px 24px',
            backgroundColor: 'white',
            color: '#ef4444',
            border: 'none',
            borderRadius: '6px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          Tentar Novamente
        </button>
      </div>
    </div>
  );
};

export default PaymentFailure;